import React, { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { collection, limit, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { dbAdmin } from "../firebaseConfig";
import { FiArrowLeft, FiShare2 } from "react-icons/fi";
import "../styles/MasjidKempen.css"; // reuse
import "../styles/KempenPublic.css"; // reuse featured card styles

const fmtRM = (n) => {
    const x = Number(n || 0);
    return `RM${x.toLocaleString("ms-MY")}`;
};

export default function MasjidKempenDetail() {
    const { slug, kempenId } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [masjid, setMasjid] = useState(null);
    const [jumlahByKempen, setJumlahByKempen] = useState(new Map());

    useEffect(() => {
        if (!slug) return;

        const s = String(slug).trim().toLowerCase();
        setLoading(true);

        const qRef = query(
            collection(dbAdmin, "masajid"),
            where("profail.slug", "==", s),
            limit(1)
        );

        const unsub = onSnapshot(
            qRef,
            (snap) => {
                if (snap.empty) {
                    setMasjid(null);
                    setLoading(false);
                    return;
                }
                const d = snap.docs[0];
                setMasjid({ id: d.id, ...d.data() });
                setLoading(false);
            },
            () => {
                setMasjid(null);
                setLoading(false);
            }
        );

        return () => unsub();
    }, [slug]);

    useEffect(() => {
        const masjidId = masjid?.id;
        if (!masjidId) return;

        const qRef = query(
            collection(dbAdmin, "masajid", masjidId, "derma_rekod"),
            orderBy("createdAt", "desc"),
            limit(200)
        );

        const unsub = onSnapshot(
            qRef,
            (snap) => {
                const map = new Map();
                snap.docs.forEach((d) => {
                    const r = d.data() || {};
                    const id = r.kempenId || r.campaignId || null;
                    if (!id) return;

                    const amaun = Number(r.amaun ?? r.amount ?? 0) || 0;
                    const status = String(r.status || "").toLowerCase();
                    const ok = status === "berjaya" || status === "paid" || status === "success";
                    if (!ok) return;

                    map.set(id, (map.get(id) || 0) + amaun);
                });
                setJumlahByKempen(map);
            },
            () => setJumlahByKempen(new Map())
        );

        return () => unsub();
    }, [masjid?.id]);

    const bannerImg = masjid?.profail?.gambar || masjid?.gambar || masjid?.profail?.logo || "";

    const kempen = useMemo(() => {
        const raw = Array.isArray(masjid?.kempen?.senarai) ? masjid.kempen.senarai : [];
        return raw.find((k) => String(k?.id) === String(kempenId)) || null;
    }, [masjid, kempenId]);

    const shareThis = async () => {
        if (!kempen) return;
        const url = `${window.location.origin}/${slug}/kempen/${kempen.id}`;
        const title = kempen?.tajuk || "Kempen Derma";

        try {
            if (navigator.share) {
                await navigator.share({ title, text: title, url });
                return;
            }
        } catch { }

        try {
            await navigator.clipboard.writeText(url);
            alert("Link kempen telah disalin.");
        } catch {
            prompt("Copy link kempen:", url);
        }
    };

    if (loading) {
        return (
            <div className="mk-page">
                <div className="mk-empty">Loading...</div>
            </div>
        );
    }

    if (!masjid) {
        return (
            <div className="mk-page">
                <div className="mk-empty">Masjid tidak ditemui.</div>
            </div>
        );
    }

    if (!kempen) {
        return (
            <div className="mk-page">
                <div className="mk-top">
                    <button className="mk-back" onClick={() => navigate(`/${slug}/kempen`)}>
                        <FiArrowLeft /> Kembali
                    </button>
                    <div className="mk-title">Kempen</div>
                </div>
                <div className="mk-empty">Kempen tidak ditemui.</div>
            </div>
        );
    }

    const raised = Number(jumlahByKempen.get(kempen.id) || 0) || 0;
    const goal = Number(kempen?.sasaran || 0) || 0;
    const hasGoal = goal > 0;
    const percent = hasGoal ? Math.max(0, Math.min(100, Math.round((raised / goal) * 100))) : 0;

    const img = kempen.imejUrl || bannerImg || "/images/150.png";

    return (
        <div className="mk-page">


            {/* guna card style yang sama macam featured */}
            <div className="kpCard">
                <div className="kpCard-img">
                    <img
                        src={img}
                        alt={kempen.tajuk || "Kempen"}
                        onError={(e) => (e.currentTarget.src = bannerImg || "/images/150.png")}
                    />
                    <div className="kpPill">Derma</div>
                </div>

                <div className="kpCard-body">
                    <div className="kpCard-title">{kempen.tajuk || "Kempen Derma"}</div>
                    <div className="kpCard-desc">{kempen.keterangan || "—"}</div>

                    {hasGoal ? (
                        <div className="kpBox">
                            <div className="kpBox-row">
                                <div className="kpBox-label">Donation</div>
                                <div className="kpBox-pct">{percent}%</div>
                            </div>

                            <div className="kpBar">
                                <div className="kpBar-fill" style={{ width: `${percent}%` }} />
                            </div>

                            <div className="kpBox-row2">
                                <div className="kpBox-amt">
                                    <div className="kpBox-amtLabel">Raised:</div>
                                    <div className="kpBox-amtValue">{fmtRM(raised)}</div>
                                </div>

                                <div className="kpBox-amt right">
                                    <div className="kpBox-amtLabel">Goal:</div>
                                    <div className="kpBox-amtValue">{fmtRM(goal)}</div>
                                </div>
                            </div>
                            <div className="mk-actions">

                                <button
                                    type="button"
                                    className="kpBtn"
                                    onClick={() => alert("Next: connect flow ToyyibPay untuk kempen ini")}
                                >
                                    Derma Sekarang
                                </button>
                                <button className="kpBtn-share" onClick={shareThis} aria-label="Share" type="button">
                                    <FiShare2 /> Share
                                </button>
                            </div>
                        </div>
                    ) : (
                        <button
                            type="button"
                            className="kpBtn"
                            onClick={() => alert("Next: connect flow ToyyibPay untuk kempen ini")}
                        >
                            Derma Sekarang
                        </button>
                    )}
                </div>
            </div>
        </div>
    );

}
